//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const lg = '(min-width: 1024px)'
const md = '(max-width: 1023.99px) and (min-width: 501px)'
const sm = '(max-width: 500.99px)'

export default {
  name: 'PagsmileCard',
  data () {
    return {
      isPC: typeof window !== 'undefined' ? window.matchMedia(lg).matches : false,
      isTablet: typeof window !== 'undefined' ? window.matchMedia(md).matches : false,
      isMobile: typeof window !== 'undefined' ? window.matchMedia(sm).matches : false,
      topArr: [
        require('@/assets/img/pagsmile-card/cards/t-1.png'),
        require('@/assets/img/pagsmile-card/cards/t-2.png'),
        require('@/assets/img/pagsmile-card/cards/t-3.png'),
        require('@/assets/img/pagsmile-card/cards/t-4.png')
      ],
      bottomArr: [
        require('@/assets/img/pagsmile-card/cards/b-1.png'),
        require('@/assets/img/pagsmile-card/cards/b-2.png'),
        require('@/assets/img/pagsmile-card/cards/b-3.png'),
        require('@/assets/img/pagsmile-card/cards/b-4.png')
      ]
    }
  },
  computed: {
    initOption1 () {
      const setting = {
        direction: 2,
        limitMoveNum: 2
      }
      if (this.isPC) {
        setting.step = 1
      } else {
        setting.step = 0.2
      }
      return setting
    },
    initOption2 () {
      const setting = {
        limitMoveNum: 2
      }
      if (this.isPC) {
        setting.direction = 3
        setting.step = 1
      } else {
        setting.direction = 2
        setting.step = 0.2
      }
      return setting
    }
  },
  mounted () {

  },
  methods: {
  }
}
